import { AlignmentType, HeadingLevel, ImageRun, Paragraph, TextRun, WidthType } from "docx";
import methodology from '../../../../../../Assests/ReportImages/approachMethodology.png'
const setupMethodology = await fetch(methodology).then(response => response.blob())


const setUpMethodologyImage = new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 500,
        height: 300
    },
});

export const methodologyHeading = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "5.  Methodology",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export const methodologyText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 376, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The primary source of increase of attacks on applications is because of insecure coding practices.  Secure code review can identify, prioritize and mitigate vulnerabilities in the deployed applications as well as applications that are under development stage. Security code review methodology has evolved from its strong application development experience, affiliation to international research forums and practice of internal standards. The following section captures the code review methodology followed by ISECURION.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const setUpAndMethodology = new Paragraph({
    spacing: { before: 300 },
    alignment: AlignmentType.CENTER,
    children: [setUpMethodologyImage]
})